import { hexToRgba } from "@/services";
import { buildingSettingsAPI } from "./api";

export const getProjectTypes = async () => {
  try {
    const res = await buildingSettingsAPI.getProjectTypes();
    return res?.data;
  } catch (e) {}
};
export const getResidentialSettingsList = async () => {
  try {
    const res = await buildingSettingsAPI.getResidentials();
    return res?.data || [];
  } catch (e) {}
};
export const getEntrances = async (params) => {
  try {
    const res = await buildingSettingsAPI.getEntrances(params);
    return (
      res?.data?.map((item) => ({
        ...item,
        entrance_name: `Подъезд ${item.entrance}`,
      })) || []
    );
  } catch (e) {}
};
export const getResidentialEntrances = async (residentId) => {
  try {
    const res = await buildingSettingsAPI.getResidentEntrances(residentId);
    return (
      res?.data?.map((item) => ({
        ...item,
        entrance_name: `Подъезд ${item.entrance}`,
      })) || []
    );
  } catch (e) {}
};
export const getEntranceApartments = async (params = {}) => {
  try {
    const res = await buildingSettingsAPI.getEntranceApartments(params);
    if (!res) return;
    return { ...res, data: res?.data?.reverse() || [] };
  } catch (e) {}
};
export const getFloorLegendInfo = async (params = {}) => {
  try {
    const res = await buildingSettingsAPI.getFloorLegendInfo(params);
    return res?.data;
  } catch (e) {}
};
export const getEntranceLegendInfo = async (params = {}) => {
  try {
    return await buildingSettingsAPI.getEntranceLegendInfo(params);
  } catch (e) {}
};
export const recalculateFloorValues = async (floor_map_id, params) => {
  try {
    const res = await buildingSettingsAPI.recalculateFloorValues(
      floor_map_id,
      params
    );
    return res?.data;
  } catch (e) {}
};
export const getEntranceColors = async (params = {}) => {
  try {
    const res = await buildingSettingsAPI.getEntranceColors(params);
    if (!res?.data) return [];
    const newGroup = { label: "Новая группа", colour_id: "new_group" };
    const groups = res.data.map((item) => ({
      ...item,
      hex_code: hexToRgba(item.hex_code, 0.5),
      label: "",
      style: { backgroundColor: hexToRgba(item.hex_code, 0.5) },
    }));
    return [newGroup, ...groups];
  } catch (e) {}
};

const floorSchemaDataRefactor = (res) => {
  const flatColors = {};
  if (res?.data?.length)
    res.data?.forEach((item) => {
      if (!flatColors[item.floor_flat_id]) {
        const flatColorsLength = Object.keys(flatColors).length;
        flatColors[item.floor_flat_id] = borderColors[flatColorsLength];
      }
    });
  const lines = res?.data?.filter((item) => item.coord_type !== "POINT");
  const circles = res?.data?.filter((item) => item.coord_type === "POINT");
  const texts = res?.data?.filter(
    (item) => !!item.frame_name && item.center_point
  );
  return {
    ...res,
    data: !!res?.data?.length,
    flatColors,
    lines,
    circles,
    texts,
  };
};
export const getFloorSchema = async (floor_map_id) => {
  const params = { floor_map_id };
  try {
    const res = await buildingSettingsAPI.getFloorSchema(params);
    if (!res) return;
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const getSchemaObjectInfo = async (floor_param_id, project_type_id) => {
  if (!floor_param_id) return;
  const params = { floor_param_id, project_type_id };
  try {
    const res = await buildingSettingsAPI.getObjectInfo(params);
    return res || null;
  } catch (e) {}
};
export const changeFloorGroup = async (body, params = {}) => {
  try {
    const res = await buildingSettingsAPI.changeFloorGroup(body, params);
    if (!res) return;
    return { ...res, data: res?.data?.reverse() || [] };
  } catch (e) {}
};
export const duplicateFloorGroup = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.duplicateFloorGroup(body, params);
    return res || null;
  } catch (e) {}
};
export const duplicateFlatToFloors = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.duplicateFlatToFloors(body, params);
    return res || null;
  } catch (e) {}
};
export const getFloorMapInfo = async (floor_map_id) => {
  try {
    const res = await buildingSettingsAPI.getFloorMapInfo(floor_map_id);
    return res?.data;
  } catch (e) {}
};
export const getFloorParamTypes = async () => {
  try {
    const res = await buildingSettingsAPI.getFloorParamTypes();
    return res?.data;
  } catch (e) {}
};
export const getFloorParamFrames = async (resident_id) => {
  try {
    const res = await buildingSettingsAPI.getFloorParamFrames({
      resident_id,
    });
    return res?.data;
  } catch (e) {}
};
export const getFloorRooms = async (floor_map_id) => {
  try {
    const res = await buildingSettingsAPI.getFloorRooms({ floor_map_id });
    return res?.data;
  } catch (e) {}
};
export const getFloorMapErrors = async (floor_map_id) => {
  try {
    const res = await buildingSettingsAPI.getFloorMapErrors(floor_map_id);
    return res?.data;
  } catch (e) {}
};
export const getFloorFlatRooms = async (floor_flat_id) => {
  try {
    const res = await buildingSettingsAPI.getFloorFlatRooms({
      floor_flat_id,
    });
    return res?.data;
  } catch (e) {}
};
export const getAllRooms = async () => {
  try {
    const res = await buildingSettingsAPI.getAllRooms();
    return res?.data;
  } catch (e) {}
};
export const createFloorFlatParamValue = async (body) => {
  try {
    const res = await buildingSettingsAPI.createFloorFlatParamValue(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};
export const deleteFloorFlatParamValue = async (body) => {
  try {
    const res = await buildingSettingsAPI.deleteFloorFlatParamValue(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};
export const updateFloorParam = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.updateFloorParam(body, params);
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const updateFloorMapLine = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.updateFloorMapLine(body, params);
    return res;
  } catch (e) {}
};
export const deleteFloorMapLine = async (floor_param_id, params = {}) => {
  if (!floor_param_id) return;
  try {
    const res = await buildingSettingsAPI.deleteFloorMapLine(
      floor_param_id,
      params
    );
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const getBufferParams = async (floor_map_id) => {
  if (!floor_map_id) return;
  try {
    const res = await buildingSettingsAPI.getBufferParams({
      floor_map_id,
    });
    const lines = res?.data?.filter((item) => item.coord_type !== "POINT");
    const circles = res?.data?.filter((item) => item.coord_type === "POINT");
    return { lines, circles };
  } catch (e) {}
};
export const addFloorMap = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.addFloorMap(body, params);
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const recalculateSmeta = async (body, params = {}) => {
  try {
    const res = await buildingSettingsAPI.recalculateSmeta(body, params);
    return res?.floor_map_info;
  } catch (e) {}
};
export const blockParamType = async (body, params) => {
  try {
    const res = await buildingSettingsAPI.blockParamType(body, params);
    return res?.data;
  } catch (e) {}
};
export const editFloorMap = async (floor_map_id, body, params) => {
  try {
    const res = await buildingSettingsAPI.editFloorMap(
      floor_map_id,
      body,
      params
    );
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};

export const getPresetMaterialSets = async (floor_map_id) => {
  try {
    const res = await buildingSettingsAPI.getPresetMaterialSets({
      floor_map_id,
    });
    return res?.data;
  } catch (e) {}
};

export const getPresetMaterials = async (material_set_id) => {
  try {
    const res = await buildingSettingsAPI.getPresetMaterials({
      material_set_id,
    });
    return (
      res?.data?.map((item) => ({
        ...item,
        label: `${item.material_set_id}-${item.material_name} (${item.consumption})`,
      })) || []
    );
  } catch (e) {}
};

export const modifyFloorParamMaterials = async (floor_param_id, body) => {
  try {
    const res = await buildingSettingsAPI.modifyFloorParamMaterials(
      floor_param_id,
      body
    );
    return res;
  } catch (e) {}
};

export const createFloorObject = async (code_type, project_entrance_id) => {
  try {
    const res = await buildingSettingsAPI.createFloorObject(
      { code_type },
      {
        project_entrance_id,
      }
    );
    return res?.data?.reverse() || [];
  } catch (e) {}
};

export const deleteFloorParamMaterial = async (
  floor_param_id,
  floor_param_material_id
) => {
  try {
    const res = await buildingSettingsAPI.deleteFloorParamMaterial(
      floor_param_id,
      floor_param_material_id
    );
    return res;
  } catch (e) {}
};

export const getRevitFloorList = async (params) => {
  try {
    const res = await buildingSettingsAPI.getRevitFloorList(params);
    return res;
  } catch (e) {}
};

export const getRevitData = async (params) => {
  try {
    const res = await buildingSettingsAPI.getRevitData(params);
    return res;
  } catch (e) {}
};

export const getProjectList = async (params = {}) => {
  try {
    const res = await buildingSettingsAPI.getProjectList(params);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const copyFloorToProject = async (floor_map_id, body) => {
  const res = await buildingSettingsAPI.copyFloorToProject(floor_map_id, body);
  return res;
};

export const createSmetaVersion = async (body) => {
  try {
    const res = await buildingSettingsAPI.createSmetaVersion(body);
    return res;
  } catch (e) {}
};

export const getAvrLockedWorks = async (project_entrance_id, floor_map_ids = null) => {
  try {
    const params = { project_entrance_id };
    if (floor_map_ids && floor_map_ids.length > 0) {
      params.floor_map_ids = floor_map_ids.join(',');
    }
    const res = await buildingSettingsAPI.getAvrLockedWorks(params);
    return res?.data || [];
  } catch (e) {
    console.error('Error loading AVR locked works:', e);
    return [];
  }
};

export const getRecalculableWorks = async (project_entrance_id, floor_map_ids = null) => {
  try {
    const params = { project_entrance_id };
    if (floor_map_ids && floor_map_ids.length > 0) {
      params.floor_map_ids = floor_map_ids.join(',');
    }
    const res = await buildingSettingsAPI.getRecalculableWorks(params);
    return res?.data || [];
  } catch (e) {
    console.error('Error loading recalculable works:', e);
    return [];
  }
};

export const getEntranceFloorsMismatch = async (params = {}) => {
  try {
    const res = await buildingSettingsAPI.getEntranceFloorsMismatch(params);
    return res?.data || null;
  } catch (e) {
    return null;
  }
};

export const flattenPoints = (pointsArray) => {
  return pointsArray.reduce((acc, [x, y]) => {
    acc.push(x, y);
    return acc;
  }, []);
};

export const checkFlatFloor = (floor, apartment, addData, isSubmit = false) => {
  if (Number(addData?.flat_num) === Number(apartment.flat_num))
    return !isSubmit;
  if (floor.is_selected) {
    const floorsOffset = Number(addData?.floor) - Number(floor.floor);
    const direction = floorsOffset > 0 ? 1 : -1;
    const offset = Math.abs(floorsOffset);
    const flatNum =
      direction === 1
        ? Number(addData?.flat_num) - offset * addData?.floorFlatLength
        : Number(addData?.flat_num) + offset * addData?.floorFlatLength;
    if (flatNum === Number(apartment.flat_num)) return true;
  }
  return false;
};

export const borderColors = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#A133FF",
  "#33FFF5",
  "#F5FF33",
  "#FF8C33",
  "#33FF8C",
  "#8C33FF",
  "#FF3333",
  "#33FF33",
  "#3333FF",
  "#FF33FF",
  "#33FFFF",
  "#FF9933",
  "#33FF99",
  "#9933FF",
  "#FF3399",
  "#3399FF",
];

export const onKonvaWheel = (e, stage) => {
  if (!stage) return;
  e.evt.preventDefault();
  // "коэффициент" скорости масштабирования
  const scaleBy = 1.15;

  // Текущий масштаб
  const oldScale = stage.scaleX();

  // Позиция курсора внутри Stage
  const pointer = stage.getPointerPosition();

  // Находим, «куда» будет масштабироваться сцена
  const mousePointTo = {
    x: (pointer.x - stage.x()) / oldScale,
    y: (pointer.y - stage.y()) / oldScale,
  };

  // Определяем направление (deltaY > 0 – отдаление, < 0 – приближение)
  const direction = e.evt.deltaY > 0 ? -1 : 1;

  // Считаем новый масштаб
  const newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

  // Устанавливаем масштаб
  stage.scale({ x: newScale, y: newScale });

  // Рассчитываем сдвиг так, чтобы точка под курсором «осталась на месте»
  const newPos = {
    x: pointer.x - mousePointTo.x * newScale,
    y: pointer.y - mousePointTo.y * newScale,
  };
  stage.position(newPos);
  stage.batchDraw();
};

export const frameColumns = [
  {
    name: "frame_param_type_name",
    label: "Параметр",
    field: "frame_param_type_name",
    align: "left",
  },
  {
    name: "param_value",
    label: "Значение",
    field: "param_value",
    align: "right",
  },
];

export const checkFlatRelations = async (floor_flat_id) => {
  try {
    const res = await buildingSettingsAPI.checkFlatRelations(floor_flat_id);
    return res;
  } catch (e) {
    console.error('Ошибка при проверке связей:', e);
    return { has_relations: false };
  }
};

export const deleteFlat = async (floor_flat_id) => {
  try {
    const res = await buildingSettingsAPI.deleteFlat(floor_flat_id);
    return res;
  } catch (e) {
    console.error('Ошибка при вызове deleteFlat API:', e);
    return {
      success: false,
      error: e?.response?.data?.error || e?.response?.data?.message || e?.message
    };
  }
};